module.exports = __webpack_public_path__ + "static/media/japandi-julie.4dad61ff.png";